import * as React from 'react';
import { isSlot } from '@fluentui/react-utilities';
import { getMetadataFromSlotComponent } from '../utils/getMetadataFromSlotComponent';
import { createCompatSlotComponent } from '../utils/createCompatSlotComponent';
/**
 * @internal
 */ export const createJSX = (runtime)=>{
    const jsxFromSlotComponent = (type, overrideProps, key, source, self)=>{
        const { elementType, renderFunction, props: slotProps } = getMetadataFromSlotComponent(type);
        const props = {
            ...slotProps,
            ...overrideProps
        };
        if (renderFunction) {
            return runtime(React.Fragment, {
                children: renderFunction(elementType, props)
            }, key, source, self);
        }
        return runtime(elementType, props, key, source, self);
    };
    return (type, overrideProps, key, source, self)=>{
        // TODO:
        // this is for backwards compatibility with getSlotsNext
        // it should be removed once getSlotsNext is obsolete
        if (isSlot(overrideProps)) {
            return jsxFromSlotComponent(createCompatSlotComponent(type, overrideProps), null, key, source, self);
        }
        if (isSlot(type)) {
            return jsxFromSlotComponent(type, overrideProps, key, source, self);
        }
        return runtime(type, overrideProps, key, source, self);
    };
};
